import React, { useState } from "react";
import { Chrome, ChromeInputType } from '@uiw/react-color';
import { Menu, Button } from "@mui/material";

type ColorPickerProps = {
    color: string,
    handleColorChange: (color: string) => void,
    experienceMode?: string;
};

const ColorPicker = ({ color, handleColorChange, experienceMode }: ColorPickerProps) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                aria-controls={open ? "horizontal-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                disabled={experienceMode === "MOD_ONLY" || experienceMode === "READ_ONLY"}
                sx={{ 
                    width: "80px",
                    height: "80px",
                    backgroundColor: color.startsWith("#") ? color : "#" + color,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                }}
            >
            </Button>
            <Menu
                id="horizontal-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    sx: {
                    padding: 0,
                    },
                }}
                PaperProps={{
                    sx: {
                    background: "none",
                    zIndex: 0
                    },
                }}
            >
                    <Chrome 
                        style={{ marginLeft: 0, zIndex: 1, position: "relative" }}
                        color={color}
                        onChange={(e) => {
                            handleColorChange(e.hex);
                        }}
                        showEyeDropper={true}
                        showAlpha={false}
                        inputType={"hexa" as ChromeInputType}
                    />
            </Menu>
        </>
    );
};

export default ColorPicker;